export default class ButtonWithVO extends Phaser.Button {
  constructor({ game, x = 0, y = 0, dy = 0, voId, bg, mask, key, atlas = 'ui_buttons' }) {
    super(game, x, y, atlas);
    console.log(bg, mask, key);
    this.frameName = bg;
    this.anchor.set(0.5);

    this.voId = voId;

    this.image = this.game.make.image(0, 0, atlas, key);
    this.image.anchor.set(0.5);
    this.image.x = this.image.width / 2;
    this.image.y = this.image.height / 2;

    this.imageMask = this.game.make.image(0, 0, atlas, mask);

    this.bmd = this.game.make.bitmapData(this.image.width, this.image.height);
    this.bmd.alphaMask(this.image, this.imageMask);

    this.icon = this.game.make.image(0, dy, this.bmd);
    this.icon.anchor.set(0.5);
    this.addChild(this.icon);

    this.data = {};
    this.isOver = false;
    this.input.useHandCursor = true;
    this.game.time.events.add(1, this.init, this);

    this.onInputDown.add(this.onDown, this);
    this.onInputOver.add(this.onOver, this);
    this.onInputOut.add(this.onOut, this);
  }

  init() {
    if (this.game) {
      const mx = this.game.input.activePointer.x;
      const my = this.game.input.activePointer.y;
      if (this.isWithinBounds(mx, my)) {
        // this.onOver();
      } else {
        // this.onOut();
      }
    }
    this.enable();
  }

  enable() {
    this.input.enabled = true;
  }

  disable() {
    this.input.enabled = false;
  }

  isWithinBounds(x, y) {
    return this.getBounds().contains(x, y);
  }

  onOver() {
    this.isOver = true;
    const tween = this.game.add.tween(this.image.scale).to({ x: 1.2, y: 1.2 }, 200, null, true);
    tween.onUpdateCallback(this.updateMask, this);
  }

  onOut() {
    this.isOver = false;
    const tween = this.game.add.tween(this.image.scale).to({ x: 1, y: 1 }, 200, null, true);
    tween.onUpdateCallback(this.updateMask, this);
  }

  updateMask(tween, value, tweenData) {
    tween;
    tweenData;
    value;

    this.bmd.alphaMask(this.image, this.imageMask);
  }

  onDown() {
    this.onInputDown.remove(this.onDown, this);
    this.onInputOver.remove(this.onOver, this);
    this.onInputOut.remove(this.onOut, this);

    this.onOver();

    this.game.sounds.playSFX('click', { spriteID: 'sfx_gameplay' });
    this.game.sounds.playVO(this.voId, {
      spriteID: 'vo_ui',
      delay: 200,
    });
    this.game.springRollCaptionsPlugin.playCaption(this.voId);
  }

  destroy() {
    this.onInputDown.removeAll();
    this.onInputOver.removeAll();
    this.onInputOut.removeAll();
    this.disable();
    super.destroy();
  }
}
